<template>
    <div>
        <b-card :header="uLang('app.duplicate_enrolment')" header-tag="h4" class="bg-default-card">
            <trajectory-enrolment-form
                v-if="relation && original"
                :relation="relation"
                :prefill="prefill"
                :override-endpoint="overrideEndpoint"
            />
        </b-card>
    </div>
</template>

<script>
    import TrajectoryEnrolmentForm from '~/components/forms/admin/relation/trajectory-enrolment/form'

    export default {
        name: 'duplicate',

        props: {
            relationId: { required: true },
            id: { required: true }, // the existing enrolment id to duplicate FROM
        },

        data() {
            return {
                relation: undefined,
                original: null,
                prefill: null,
            };
        },

        components: {
            'trajectory-enrolment-form': TrajectoryEnrolmentForm,
        },

        created() {
            this.retrieveRelation();
            this.retrieveSourceEnrolment();
        },

        methods: {
            async retrieveRelation() {
                const { data } = await window.axios.get('/api/admin/relations/' + this.relationId);
                this.relation = data;
            },
            async retrieveSourceEnrolment() {
                const enrRes = await window.axios.get(
                    route('relations.trajectory-enrolments.show', {
                        relation: this.relationId,
                        trajectory_enrolment: this.id,
                    })
                    );
                    this.original = enrRes.data;

                    // Build prefill payload (exclude start/end dates)
                    const o = this.original;
                    this.prefill = {
                        client_id: o.client_id,
                        trajectory_project_id: o.trajectory_project_id,
                        trajectory_id: o.trajectory_id,
                        contact_id: o.contact_id,
                        reporting_person_id: o.reporting_person_id,
                        trajectory_manager_id: o.trajectory_manager_id,
                        casemanager_id: o.casemanager_id,
                        customer_number_according_to_client: o.customer_number_according_to_client,
                        receives_lead_person_id: o.receives_lead_person_id,
                        receives_lead_organisation_id: o.receives_lead_organisation_id,
                        receives_acquisition_person_id: o.receives_acquisition_person_id,
                        receives_acquisition_organisation_id: o.receives_acquisition_organisation_id,
                        trajectory_price_excluding_vat: o.trajectory_price_excluding_vat,
                        duplicate_from_id: this.id, // original enrolment id
                        // dates intentionally omitted
                    };

                    console.log('Prefill data:', this.prefill);
            },
        },

        computed: {
            overrideEndpoint() {
                return route('relations.trajectory-enrolments.store', {relation: this.relationId});
            }
        }
    }
</script>

<style lang="css" scoped>
</style>
